<script setup lang="ts">
export interface Props {
  isLoading?: boolean;
  isError?: boolean;
  counter?: number;
}
const props = withDefaults(defineProps<Props>(), {
  isLoading: false,
  isError: false,
  counter: 0,
});
</script>

<template>
  <div :class="$style.noticesStatusBadge" data-testid="noticesStatusBadge">
    <template v-if="props.isLoading">
      <v-progress-circular
        :class="$style.spinner"
        indeterminate
        :size="10.5"
        :width="2"
      >
      </v-progress-circular>
    </template>
    <template v-else-if="props.isError">!</template>
    <template v-else>
      {{ props.counter }}
    </template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.noticesStatusBadge {
  background-color: colors.$color-brand-800;
  font-size: 0.625rem;
  vertical-align: middle;
  color: colors.$color-white;
  font-weight: 600;
  padding: 0 5px;
  border-radius: 1rem;
  height: 1rem;
  min-width: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
  .spinner {
    margin-left: -3px;
    margin-right: -3px;
  }
</style>
